const React = require('react');
const RadioButtonModal = require('./radioButtonModal.jsx.js').RadioButtonModal;
const TextInputModal = require('./textInputModal.jsx.js').TextInputModal;
const AjaxFunctions = require('../ajaxFunctions');
const ToastAlert = require('./toastAlert');
const SharedConstants = require('../../../../shared/sharedConstants');

import MultipleInputModal from './multipleInputModal';
import FavoriteButton from './favoriteButton.jsx';
import { createUrlForCard } from '../utils';

import Toastr from 'toastr';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux/dist/react-redux.min.js';
import { Button, Select, MenuItem, IconButton, Tooltip } from '@material-ui/core';

Toastr.options.positionClass = 'toast-bottom-full-width';

let tooltipTitle = (title) => {
   return (
      <React.Fragment>
         <div style={{ fontSize: SharedConstants.TooltipValue.FontSize, lineHeight: SharedConstants.TooltipValue.LineHeight }}>
            {title}
         </div>
      </React.Fragment>
   )
};

class CardFunctions extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
         showPortfolioModal: false,
         showIncubatorModal: false,
         showReportModal: false,
         sIncubator: '',
         sPortfolio: '',
      }
   }

   async addCardToIncubator() {
      try {
         const { incubators } = this.props;
         const { sIncubator } = this.state;
         const incubator = incubators.filter(i => i.id == sIncubator)[0];
         let result = await AjaxFunctions.addCardToEndOfPortfolio(
            this.state.sIncubator,
            this.props.card.id,
            this.props.card.cardType,
         );
         let pointAwardResult = result.pointAwardResult?result.pointAwardResult:"Your Incubator"
         let toastString = pointAwardResult+' is now in review. <a href="/incubator?idIncubator='
            + incubator.id
            + '">"<u>'
            + incubator.name
            + '</u>"</a>';
         Toastr.success(toastString);
      } catch(err) {
         Toastr.error(err);
      }
   }

   async addCardToPortfolio() {
      const { portfolios } = this.props;
      const { sPortfolio } = this.state;
      const portfolio = portfolios.filter(p => p.id == sPortfolio)[0];
      try {
         await AjaxFunctions.addCardToEndOfPortfolio(sPortfolio, this.props.card.id, this.props.card.cardType);
         let toastString = `Added µPub to <a href="/portfolio?idPortfolio=${portfolio.id}">"<u>${portfolio.name}</u>"</a>`
         Toastr.success(toastString);
      } catch(err) {
         Toastr.error(err);
      }
   }

   async reportCard(message) {
      Toastr.options.positionClass = 'toast-bottom-full-width';
      try {
         await AjaxFunctions.reportCard(this.props.card.cardType, this.props.card.id, message);
         Toastr.success(`Report Submitted.`);
      } catch(err) {
         Toastr.error(err);
      }
   }

   async handleShareComment() {
      const { card } = this.props;
      navigator.clipboard.writeText(createUrlForCard(card.id, card.cardType));
      ToastAlert.success("Copied Link!");
  }

   render() {
      const { portfolios, incubators, card } = this.props;
      const { showPortfolioModal, showIncubatorModal, sPortfolio, sIncubator, reason } = this.state;
      const filteredIncubators = incubators.filter(i => (!i.suggestionEndTime || new Date() < new Date(i.suggestionEndTime)));
      const filteredPortfolios = portfolios 
         ? portfolios.filter(portfolio => portfolio.privacyType == SharedConstants.PortfolioType.Default) 
         : [];
      
      return (
         <div className='additional-functions'>
            <div className='first-group'>
               {!window.location.toString().includes('incubator?') && 
                  <Button
                     disabled={filteredIncubators.length == 0}
                     className='suggest-btn'
                     onClick={() => this.setState({ showIncubatorModal: true })}
                     style={{ textTransform: 'none' }}
                     color='primary'
                     variant='contained'
                     size='medium'
                  >
                     <div>Suggest for Incubator</div>
                  </Button>
               }
               <Button
                  disabled={filteredPortfolios.length == 0}
                  className='add-btn'
                  onClick={() => this.setState({ showPortfolioModal: true })}
                  style={{ textTransform: 'none' }}
                  color='primary'
                  variant='contained'
                  size='medium'
               >
                  <div>Add to Portfolio</div>
               </Button>
            </div>
            <div className='second-group'>
               <FavoriteButton card={card} />
               <Tooltip title={tooltipTitle('Share MicroPub')}>
                  <IconButton
                     aria-label='Share microPub'
                     onClick={() => this.handleShareComment()}
                  >
                     <FontAwesomeIcon icon={['far','share']} size={'1x'} />
                  </IconButton>
               </Tooltip>
               <Tooltip title={tooltipTitle('Report MicroPub')}>
                  <IconButton
                     aria-label='Report microPub'
                     onClick={() => this.setState({ showReportModal: true })}
                  >
                     <FontAwesomeIcon icon={['far','flag']} size={'1x'} />
                  </IconButton>
               </Tooltip>
            </div>
            <MultipleInputModal
                  show={showPortfolioModal}
                  contentText='Select a portfolio to add this &#181;Pub to'
                  confirmText='Add'
                  confirmFunction={() => this.addCardToPortfolio()}
                  confirmDisabled={!sPortfolio}
                  closeFunction={() => this.setState({ showPortfolioModal: false })}
               >
                  <Select
                     label='Select a portfolio'
                     value={sPortfolio}
                     onChange={event => this.setState({ sPortfolio: event.target.value })}
                  >
                     {filteredPortfolios.map(({ id, name }) => 
                        <MenuItem key={id} value={id}>{name}</MenuItem>
                     )}
                  </Select>
               </MultipleInputModal>
               <MultipleInputModal
                  show={showIncubatorModal}
                  contentText='Select an incubator to suggest this &#181;Pub to:'
                  confirmText='Suggest'
                  confirmFunction={() => this.addCardToIncubator()}
                  confirmDisabled={!sIncubator}
                  closeFunction={() => this.setState({ showIncubatorModal: false })}
               >
                  <Select
                     label='Select an incubator'
                     value={sIncubator}
                     onChange={event => this.setState({ sIncubator: event.target.value })}
                  >
                     {filteredIncubators.map(({ id, name }) => 
                        <MenuItem key={id} value={id}>{name}</MenuItem>
                     )}
                  </Select>
               </MultipleInputModal>
               <RadioButtonModal
                  show={this.state.showReportModal}
                  contentText={'Report Card'}
                  label='Report Card'
                  confirmText={'Submit'}
                  radioButtons={["This microPub does not reflect professional behavior.","I do not think this is true."]}
                  confirmFunction={(selectedValue) => this.reportCard(selectedValue)}
                  closeFunction={() => this.setState({ showReportModal: false })}
               />
         </div>
      );
   }
}

const mapCardFunctionsStateToProps = (state) => ({
   portfolios: state.PortfolioReducer.portfolioList.owned,
   incubators: state.PortfolioReducer.portfolioList.sponsored.filter(i => i.idBracket == null),
});

export default connect(mapCardFunctionsStateToProps, () => {})(CardFunctions);